<template>
	<div v-bind:class="['form', { transition }]">
		<h3>
			Join Provider
		</h3>
		<template v-if="query.auth && query.invite_token">
			<p v-if="verifySuccess" class="success message">
				<CheckIcon class="icon"></CheckIcon>
				Please choose a strong password of at least 6 characters.
			</p>
			<p v-else-if="verifyError" class="error message">
				The invitation has expired or has already been used. Please ask your care provider to resend the invitation.
			</p>
			<p v-else class="message">
				Verifying your invitation...
			</p>

			<!-- Password input -->
			<PasswordInput
				v-show="verifySuccess"
				:autofocus="true"
				v-model="password"
				v-bind:error="passwordError"
				@next="login">
			</PasswordInput>

			<!-- Login button -->
			<button
				v-if="verifySuccess"
				v-bind:class="{ disabled: authenticating }"
				v-on:click="invite">
				Set Password
			</button>
		</template>
		<template v-else>
			<!-- Username input -->
			<EmailInput
				:autofocus="true"
				v-model="email"
				v-bind:error="emailError">
			</EmailInput>

			<!-- Login button -->
			<button v-bind:class="['primary', { 'disabled': authenticating }]"
				v-on:click="login">
				next
			</button>
		</template>
	</div>
</template>

<script>
import AuthForm from '.'

export default {
	name: 'invite-form',
	extends: AuthForm,

	data() {
		return {
			verifySuccess: null,
			verifyError: null
		}
	},

	mounted() {
		if (this.query.auth && this.query.invite_token) {
			this.verifyInvite(this.query).then((result) => {
				this.verifySuccess = result
			})
			.catch((error) => {
				this.verifyError = error
			})
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>
